import { SiteConfigurationTemplate } from '../types';

export const validateAndParseTemplate = (json: unknown): SiteConfigurationTemplate => {
  if (!json || typeof json !== 'object' || Array.isArray(json)) {
    throw new Error('Invalid template: file must be a JSON object.');
  }
  const obj = json as Record<string, unknown>;
  const rawGateways = obj.gateways;
  if (!Array.isArray(rawGateways)) {
    throw new Error('Invalid template: "gateways" must be an array.');
  }

  for (const [index, gw] of rawGateways.entries()) {
    if (!gw || typeof gw !== 'object' || Array.isArray(gw)) {
      throw new Error(`Invalid template: gateway at index ${index} must be an object.`);
    }
    const g = gw as Record<string, unknown>;
    if (typeof g.idempotencyKey !== 'string' || !g.idempotencyKey) {
      throw new Error(
        `Invalid template: gateway at index ${index} is missing a string "idempotencyKey".`
      );
    }
    if (typeof g.name !== 'string' || !g.name) {
      throw new Error(
        `Invalid template: gateway "${g.idempotencyKey}" is missing a string "name".`
      );
    }
    if (g.tags === undefined || g.tags === null) {
      g.tags = {};
    } else if (typeof g.tags !== 'object' || Array.isArray(g.tags)) {
      throw new Error(
        `Invalid template: gateway "${g.idempotencyKey}" — "tags" must be an object.`
      );
    }
  }

  const arrayFields = ['controllers', 'assets', 'alarmRules', 'widgets'] as const;
  for (const field of arrayFields) {
    if (obj[field] === undefined || obj[field] === null) {
      obj[field] = [];
    } else if (!Array.isArray(obj[field])) {
      throw new Error(`Invalid template: "${field}" must be an array.`);
    }
  }

  if (obj.sitePreview === undefined || obj.sitePreview === null) {
    obj.sitePreview = { tags: [] };
  } else if (typeof obj.sitePreview !== 'object' || Array.isArray(obj.sitePreview)) {
    throw new Error('Invalid template: "sitePreview" must be an object.');
  } else {
    const sitePreview = obj.sitePreview as Record<string, unknown>;
    if (sitePreview.tags === undefined || sitePreview.tags === null) {
      sitePreview.tags = [];
    } else if (!Array.isArray(sitePreview.tags)) {
      throw new Error('Invalid template: "sitePreview.tags" must be an array.');
    }
  }

  return obj as unknown as SiteConfigurationTemplate;
};
